import { IconArrowsHorizontal } from '@tabler/icons-react';

import { registerBlockPlugin } from '../../core/BlockPluginRegistry';
import type { BlockPlugin } from '../../core/types';
import { SectionLandscapeBlockView } from './SectionLandscapeBlockView';

export const sectionLandscapePlugin: BlockPlugin = {
    name: 'sectionLandscape',
    displayName: 'Landscape Section',
    hasData: false,
    Component: SectionLandscapeBlockView,
    toolbarInsert: {
        icon: <IconArrowsHorizontal size={16} />,
        title: 'Landscape Section',
        description: 'Switch to landscape orientation',
        category: 'break'
    }
};

registerBlockPlugin(sectionLandscapePlugin);
